import React from 'react';
import {Redirect} from 'react-router-dom';
import {FuseUtils} from '@fuse/index';
import _ from 'lodash';
import { authRoles }             from 'auth/auth';
import { DashboardConfig }       from 'main/content/dashboard/DashboardConfig';
import { ExampleConfig }         from 'main/content/example/ExampleConfig';
import { InstructorConfig }      from 'main/content/instructor/InstructorConfig';
import { AuthConfig }            from 'main/content/auth/AuthConfig';
import { AuthCrudConfig }        from 'main/content/auth/AuthCrudConfig';
import { CourseConfig }          from 'main/content/course/CourseConfig';
import { LessonConfig }          from 'main/content/lesson/LessonConfig';
import { MajorConfig }           from 'main/content/major/MajorConfig';
import { AssignmentConfig }      from 'main/content/assignment/AssignmentConfig';
import { StudentConfig }         from 'main/content/student/StudentConfig';
import { ModuleConfig }          from 'main/content/module/ModuleConfig';
import { QuizConfig }            from 'main/content/quiz/QuizConfig';
import { CompanyConfig }         from 'main/content/company/CompanyConfig';
import { AssetConfig }           from 'main/content/asset/AssetConfig';
import { ScheduledCourseConfig } from 'main/content/scheduled_course/ScheduledCourseConfig';
import { GradebookConfig }       from 'main/content/gradebook/GradebookConfig';
import { NoteConfig }            from 'main/components/note/NoteConfig';
import { QualificationConfig }   from 'main/content/qualification/QualificationConfig';
import { EnrollmentConfig }      from 'main/content/enrollment/EnrollmentConfig';
import { NotificationConfig }    from 'main/content/notification/NotificationConfig';
import { PermissionConfig }      from 'main/content/permission/PermissionConfig';
import { UtilsConfig }           from 'main/content/utils/UtilsConfig';
import { ProgressConfig }        from 'main/content/progress/ProgressConfig';

function setUserAuth(configs) {
    return configs.map(config => _.merge({}, config, {auth: authRoles.user}));
}

// function setStudentAuth(configs) {
//     return configs.map(config => _.merge({}, config, {auth: authRoles.student}))
// }

function setInstructorAuth(configs) {
    return configs.map(config => _.merge({}, config, {auth: authRoles.instructor}))
}

const routeConfigs = [
    ...setUserAuth([
        DashboardConfig,
        AssignmentConfig,
        ExampleConfig,
        InstructorConfig,
        CourseConfig,
        LessonConfig,
        MajorConfig,      
        StudentConfig,
        ModuleConfig,
        QuizConfig,
        CompanyConfig,
        AssetConfig,
        ScheduledCourseConfig,
        GradebookConfig,
        NoteConfig,
        QualificationConfig,
        EnrollmentConfig,
        AuthCrudConfig,
        NotificationConfig,
        PermissionConfig,
        UtilsConfig,
        ProgressConfig
    ]),
    ...setInstructorAuth([]),
    AuthConfig,
];

export const routes = [
    ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
    {
        path     : '/',
        component: () => <Redirect to="/dashboard/"/>
    }
];



// WEBPACK FOOTER //
// src/fuse-configs/fuseRoutesConfig.js